import type {
  IControlSettingData,
  IDynamicControlSetting,
} from '~/presentation/reports/common/type';

import { EReportControlId, IRMetricKey } from '~/presentation/reports/common/type';
import { DEFAULT_FILTER_PRESET } from './default-filter';
import { DEFAULT_UI_PRESET } from './default-ui';
import { getMetricSettingUIs } from '../utils';

const LIST_METRIC = [IRMetricKey.REVENUE, IRMetricKey.RPV];
export const REVENUE_PRESET: IControlSettingData = {
  [EReportControlId.METRICS_FILTER]: {
    value: LIST_METRIC,
  },
  [EReportControlId.METRIC]: {
    value: LIST_METRIC[0],
  },
  ...DEFAULT_FILTER_PRESET,
};

export const REVENUE_UI_PRESET: IDynamicControlSetting = {
  ...DEFAULT_UI_PRESET,
  [EReportControlId.METRICS_FILTER]: getMetricSettingUIs(LIST_METRIC),
};
